export default {
  aoc: 1,
  ao: 2,
  broker: 3,
};
